module.exports = __webpack_public_path__ + "img/suv.acd47cb0.jpg";